export function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="border-b border-border">
      <div className="px-8 py-6 flex items-center justify-between gap-4">
        <div>
          {eyebrow ? <div className="label-mono mb-1">{eyebrow}</div> : null}
          <h1 className="font-display font-black text-2xl sm:text-3xl leading-tight">{title}</h1>
          {subtitle ? <p className="text-sm text-muted-foreground mt-1">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
      </div>
    </div>
  );
}

export function StatusPill({ status }) {
  const cls = {
    Present: "status-present",
    Late: "status-late",
    Absent: "status-absent",
    Missing_Punch_Out: "status-missing",
    Rejected: "status-rejected",
  }[status] || "status-absent";
  return (
    <span data-testid={`status-${status}`} className={`inline-flex items-center px-2 py-0.5 text-[10px] font-mono-brand uppercase tracking-widest ${cls}`}>
      {status?.replace("_", " ")}
    </span>
  );
}
